<script setup lang="ts">
import Dialog from '@jaaluu/components/Dialog.vue';
import stores from '@jaaluu/stores';
import { t } from '@shared/i18n';
import { Language } from '@shared/openapi/jaaluu-api/types.gen';
import { watch } from 'vue';
import SelectLanguages from './SelectLanguages.vue';

const { langSettingsOpen, showPinyin } = stores.settings.state;
const { saveShowPinyinInLocalStorage } = stores.settings.funcs;
const { langLevel, langForeign, langNative } = stores.language.state;
const { setLangLevelToLocalStore } = stores.language.funcs;

const atClose = ( )=> {
  if (langForeign.value && langNative.value) {
    langSettingsOpen.value = false
  }
}

watch(
  () => langLevel.value,
  () => {
    setLangLevelToLocalStore(langLevel.value);
  }
);

watch(
  () => showPinyin.value,
  (val) => {
    saveShowPinyinInLocalStorage(val);
  }
);
</script>

<template>
  <Dialog
    v-model="langSettingsOpen"
    :max-width="400"
    @close="atClose"
    :title="t('general.settings')"
    persistent
  >
  <div class="mb-4">
    <SelectLanguages />
  </div>

  <div v-if="langForeign === Language.ZH" class="mt-2">
    <v-switch
      v-model="showPinyin"
      color="primary"
      :label="t('settings.show_pinyin')"
      hide-details
    />
  </div>

    <!-- <div class="mt-12">
      <div class="title-sm">{{ t('settings.lang_level') }}</div>
      <v-radio-group v-model="langLevel" row color="primary">
        <v-radio :label="t('general.beginner')" :value="LanguageLevel.A1_A2" />
        <v-radio :label="t('general.advanced')" :value="LanguageLevel.C1_C2" />
      </v-radio-group>
    </div> -->
  </Dialog>
</template>
<style lang="scss" scoped></style>
